"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { forwardRef, useMultiStyleConfig, Box } from "@chakra-ui/react";
import { Variant, DatePickerVariant, } from "./DatePicker.types";
import { DateInput } from "./DateInput";
import { Header } from "./Header";
const DEFAULT_PLACEHOLDER = "- -/- -/- - - -";
const DEFAULT_LOCALE = "en-US";
const DatePicker = forwardRef((_a, ref) => {
    var { title, helpText, placeholder = DEFAULT_PLACEHOLDER, mandatory = false, dateFnsLocaleModule, locale: userLanguage, format = "dd/MM/yyyy", variant, value, onChange, showTimeInput, startDate, endDate, selectsStart, selectsEnd, minDate, maxDate, timeInputLabel = "Time", window = 50, id, resetDateCustom } = _a, rest = __rest(_a, ["title", "helpText", "placeholder", "mandatory", "dateFnsLocaleModule", "locale", "format", "variant", "value", "onChange", "showTimeInput", "startDate", "endDate", "selectsStart", "selectsEnd", "minDate", "maxDate", "timeInputLabel", "window", "id", "resetDateCustom"]);
    const styles = useMultiStyleConfig("DatePicker", { variant });
    const [locale, setLocale] = useState(DEFAULT_LOCALE);
    const [localeModule, setLocaleModule] = useState();
    const resetDate = useCallback(() => {
        if (resetDateCustom) {
            resetDateCustom();
        }
        else {
            onChange(null);
        }
    }, [onChange, resetDateCustom]);
    useEffect(() => {
        if (dateFnsLocaleModule) {
            setLocaleModule(dateFnsLocaleModule);
            setLocale(dateFnsLocaleModule.code || DEFAULT_LOCALE);
        }
        else {
            const language = userLanguage || navigator.language;
            import(`date-fns/locale/${language}/index.js`)
                .then((module) => {
                setLocaleModule(module);
                setLocale(language);
            })
                .catch(() => {
                setLocale(DEFAULT_LOCALE);
                // eslint-disable-next-line no-console
                console.error(`Could not find the date format for "${language}". Default date format is "en-US"`);
            });
        }
    }, [dateFnsLocaleModule, userLanguage]);
    return (_jsx(Box, Object.assign({ sx: styles.datePicker }, { children: _jsx(ReactDatePicker, { customInput: _jsx(DateInput, Object.assign({ ref: ref, label: title, placeholderInput: placeholder, helpText: helpText, mandatory: mandatory, variant: variant === DatePickerVariant.DEFAULT ||
                    variant === DatePickerVariant.RANGE_PICKER ||
                    variant === DatePickerVariant.RANGE_PICKER_RIGHT
                    ? undefined
                    : variant, datePickerVariant: variant, resetDate: resetDate, format: format }, rest)), id: id, disabled: variant === Variant.READONLY, showPopperArrow: false, renderCustomHeader: (args) => (_jsx(Header, Object.assign({ localeModule: localeModule, locale: locale, window: window }, args))), dateFormat: format, calendarStartDay: 1, useWeekdaysShort: true, locale: localeModule, selected: value, onChange: onChange, showTimeInput: showTimeInput, startDate: startDate, endDate: endDate, selectsStart: selectsStart, selectsEnd: selectsEnd, minDate: minDate, maxDate: maxDate, timeInputLabel: timeInputLabel }) })));
});
DatePicker.displayName = "DatePicker";
export default DatePicker;
//# sourceMappingURL=DatePicker.js.map